<div class="block-ui-template">
  <div class="lightLoader">
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 20 20" style="enable-background:new 0 0 20 20;" xml:space="preserve">
      <style type="text/css">
        .st0{opacity:0.6;fill:#FFFFFF;}
        .st1{opacity:0.2;fill:#FFFFFF;}
      </style>
            <g>
        <g>
          <path class="st0" d="M2.59,15.56C1.37,13.95,0.72,12.03,0.72,10c0-1.68,0.46-3.32,1.32-4.75l1.77,1.06C3.14,7.42,2.78,8.7,2.78,10
            c0,1.58,0.5,3.07,1.45,4.33L2.59,15.56z"/>
          <path class="st1" d="M10,19.24c-2.94,0-5.64-1.34-7.41-3.67l1.65-1.24c1.38,1.82,3.48,2.86,5.76,2.86c3.98,0,7.22-3.22,7.22-7.18
            S13.98,2.82,10,2.82c-2.56,0-4.87,1.31-6.19,3.49L2.04,5.25C3.71,2.48,6.76,0.76,10,0.76c5.12,0,9.28,4.14,9.28,9.24
            S15.12,19.24,10,19.24z"/>
        </g>
      </g>
    </svg>
  </div>
</div>
